/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseModuleData } from './genericApiResponseModuleData';
import type { GenericApiResponseModuleMessage } from './genericApiResponseModuleMessage';
import type { GenericApiResponseModulePagination } from './genericApiResponseModulePagination';
import type { GenericApiResponseModuleError } from './genericApiResponseModuleError';

export interface GenericApiResponseModule {
  data?: GenericApiResponseModuleData;
  message?: GenericApiResponseModuleMessage;
  pagination?: GenericApiResponseModulePagination;
  error?: GenericApiResponseModuleError;
  statusCode?: number;
}
